export default __webpack_public_path__ + "static/media/home.0ad2f08c.svg";